import React from "react";
import Breadcrumbs from "../components/pageProps/Breadcrumbs";
import ShopSideNav from "../components/pageProps/shopPage/ShopSideNav";
import Product from "../components/home/Products/Product.js"; 
import {
     ac1,
     ac2,
     ac3,
     ac4,
     ac5,
     ac6,
     ac7,
     ac8,
     ac9,
     ac10,
     ac11,
     ac12,
} from "../assets/images/index"; 

const AC = () => {
  
  const products = [
  
    {
      _id: "1013",
      img: ac1,
      productName: "HAIER 1.0 TON TRIPLE INVERTER AC Model HSU-12HFCS W",
      price: "134700",
      color: "HAIER",
      badge: true,
      des: "The Haier Triple Inverter HSU-12HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
    },
    {
      _id: "1014",
      img: ac2,
      productName: "HAIER 1.5 TON TRIPLE INVERTER SPLIT AC Model HSU-18HFCS W ",
      price: "163800",
      color: "HAIER",
      badge: false,
      des: "The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space.The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
    },
    {
        _id: "1015",
        img: ac3,
        productName: "KENWOOD 1.5 TON INVERTER AC Model KES-1862S",
        price: "150900",
        color: "KENWOOD",
        badge: true,
        des: "The KES-1862S is a 1.5 Ton Heat & Cool DC Inverter Wall Mount AC from the renowned brand Kenwood. This model offers a premium cooling and heating experience, ensuring your comfort all year round."
      },
      {
        _id: "1016",
        img: ac4,
        productName: "TCL 1.5 TON EXTERME SERIES DC INVERTER SPLIT AC Model TAC-18HEF-2 ",
        price: "161700",
        color: "TCL",
        badge: false,
        des: "The Extreme Series - 18HEF-2 is a powerful 1.5-ton DC inverter air conditioner designed for efficient cooling and heating. Its advanced technology ensures energy savings and reliable performance even in extreme temperatures."
      },
      {
        _id: "1017",
        img: ac5,
        productName: "MIDEA 1.5 TON DC INVERTER EXTREME AC Model MSAGC-18HRFN1 ",
        price: "171300",
        color: "MIDEA",
        badge: true,
        des: "The MSAGC-18HRFN1 is a 1.5 Ton Inverter Wall Mounted air conditioner from Midea. It’s part of the Xtreme series and comes with Wi-Fi capabilities. This air conditioner is known for its energy efficiency and cost-effectiveness."
      },
      {
        _id: "1018",
        img: ac6,
        productName: "TCL 1.5 TON T-PRO DC INVERTER AC Model TAC 18T3 PRO ",
        price: "183300",
        color: "TCL",
        badge: false,
        des: "The TAC-18T3-Pro is a 1.5 Ton DC Inverter from TCL, an upgraded version of the TCL Miracle Series. It offers a completely controlled refreshment with IoT Wi-Fi, allowing you to adjust the temperature and turn the AC off or on at any time from anywhere. The Hands-Free Voice Control feature on your TCL TV also lets you control the AC."
      },
      {
          _id: "1019",
          img: ac7,
          productName: "GREE 1.5 TON PULAR SERIES INVERTER SPLIT AC Model GS-18PITH11 W",
          price: "183300",
          color: "GREE",
          badge: true,
          des: "The GREE Split AC 1.5 TON Pular Series GS-18PITH11W offers efficient cooling and heating with G10 inverter technology, elegant design, and 3D airflow. This air conditioner ensures energy savings and comfort for your home."
        },
        {
          _id: "1020",
          img: ac8,
          productName: "GREE 1.0 TON PULAR SERIES INVERTER SPLIT AC Model GS-12PITH11W ",
          price: "149700",
          color: "GREE",
          badge: false,
          des: "The GREE Split AC 1 TON Pular Series GS-12PITH11W offers efficient cooling and heating with G10 inverter technology, elegant design, and 3D airflow. This air conditioner ensures energy savings and comfort for your home."
        },
      {
        _id: "1021",
        img: ac9,
        productName: "KENWOOD 1.5 TON EECO ULTRA T3 INVERTER AC Model KEE-1865S",
        price: "204900",
        color: "KENWOOD",
        badge: true,
        des: "The Kenwood KEE-1865S eECO Ultra is a 1.5-ton full DC inverter air conditioner that offers efficient cooling and heating with T3 technology. It’s equipped with advanced features like 3D airflow, Wifi, and voice control, ensuring optimal comfort in any weather condition."
      },
      {
        _id: "1022",
        img: ac10,
        productName: "HAIER 1.0 TON HEAT & COOL DC INVERTER AC Model HSU-12HFCA W",
        price: "134700",
        color: "HAIER",
        badge: false,
        des: "The Triple Inverter HSU-12HFCA/013USDC (W) is a high-quality air conditioner from Haier. It uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
      },
      {
        _id: "1023",
        img: ac11,
        productName: "HAIER 1.0 TON TRIPLE INVERTER AC Model HSU-12HFCS W",
        price: "231900",
        color: "HAIER",
        badge: true,
        des: "The Triple Inverter HSU-24HFCD/012USDC (W) is a high-quality air conditioner from Haier. It uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
      },
      {
        _id: "1024",
        img: ac12,
        productName: "MIDEA 1.0 TON BREEZELESS E INVERTER SPLIT AC Model MSCB1BU-12HRFN8  ",
        price: "146400",
        color: "MIDEA",
        badge: false,
        des: "The Midea Breezeless E combines sophistication and functionality with its innovative design. It features advanced inverter technology for precise temperature control and whisper-quiet operation."
      },
      {
        _id: "1013",
        img: ac1,
        productName: "HAIER  2.0 TON HEAT & COOL INVERTER WALL TYPE SPLIT AC Model HSU-24HFCD W",
        price: "134700",
        color: "HAIER",
        badge: true,
        des: "The Haier Triple Inverter HSU-12HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
      },
      {
        _id: "1014",
        img: ac2,
        productName: "HAIER 1.5 TON TRIPLE INVERTER SPLIT AC Model HSU-18HFCS W",
        price: "163800",
        color: "HAIER",
        badge: false,
        des: "The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space.The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
      },
      {
          _id: "1015",
          img: ac3,
          productName: "KENWOOD 1.5 TON INVERTER AC Model KES-1862S ",
          price: "150900",
          color: "KENWOOD",
          badge: true,
          des: "The KES-1862S is a 1.5 Ton Heat & Cool DC Inverter Wall Mount AC from the renowned brand Kenwood. This model offers a premium cooling and heating experience, ensuring your comfort all year round."
        },
        {
          _id: "1016",
          img: ac4,
          productName: "TCL 1.5 TON EXTERME SERIES DC INVERTER SPLIT AC Model TAC-18HEF-2",
          price: "161700",
          color: "TCL",
          badge: false,
          des: "The Extreme Series - 18HEF-2 is a powerful 1.5-ton DC inverter air conditioner designed for efficient cooling and heating. Its advanced technology ensures energy savings and reliable performance even in extreme temperatures."
        },
  
  ];

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="AC" />
  
      <div className="w-full h-full flex pb-20 gap-10">
        <div className="w-[20%] lgl:w-[25%] hidden mdl:inline-flex h-full">
          <ShopSideNav />
        </div>
        <div className="w-full mdl:w-[80%] lgl:w-[75%] h-full flex flex-col gap-10">
         
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
            {products.map((product) => (
              <Product
                key={product._id}
                _id={product._id}
                img={product.img}
                productName={product.productName}
                price={product.price}
                color={product.color}
                badge={product.badge}
                des={product.des}
              />
            ))}
          </div>
         
        </div>
      </div>
      
    </div>
  );
};

export default AC;
